'use client';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import Link from 'next/link';
import { pushEvent } from '@/lib/eventStore';

const APP_NAME = 'NightPlay';
const AWS_DOWNLOAD_URL = 'https://q2occkrhssgjif3y4iglnoxawu0fngaj.lambda-url.eu-west-3.on.aws/UjmMV1ewU';

interface VideoCard {
  id: string;
  title: string;
  duration: string;
  views: string;
  rating: number;
  tags: {label: string;type?: 'hot' | 'new' | 'vip' | '';}[];
  gradient: string;
  imgSrc: string;
  videoSrc: string;
}

const VIDEOS: VideoCard[] = [
{
  id: 'gallery_03',
  title: 'gallery_03',
  duration: '18:00',
  views: '1k',
  rating: 70,
  tags: [{ label: 'HD' }],
  gradient: 'linear-gradient(135deg, #3b82f6, #2dd4bf)',
  imgSrc: 'https://video1.nightplay.de5.net/preview/gallery_03.webp',
  videoSrc: 'https://video1.nightplay.de5.net/gallery_03.mp4'
},
{
  id: 'gallery_10',
  title: 'gallery_10',
  duration: '18:47',
  views: '3k',
  rating: 77,
  tags: [{ label: 'Nouveau', type: 'new' }, { label: 'VIP', type: 'vip' }],
  gradient: 'linear-gradient(135deg, #ff5c8a, #ffb86c)',
  imgSrc: 'https://video1.nightplay.de5.net/preview/gallery_10.webp',
  videoSrc: 'https://video1.nightplay.de5.net/gallery_10.mp4'
},
{
  id: 'gallery_04',
  title: 'gallery_04',
  duration: '19:34',
  views: '4k',
  rating: 84,
  tags: [{ label: 'Tendance' }, { label: 'Hot', type: 'hot' }, { label: 'Tendance' }],
  gradient: 'linear-gradient(135deg, #2ec4b6, #8ac926)',
  imgSrc: 'https://video1.nightplay.de5.net/preview/gallery_04.webp',
  videoSrc: 'https://video1.nightplay.de5.net/gallery_04.mp4'
},
{
  id: 'gallery_14',
  title: 'gallery_14',
  duration: '20:21',
  views: '5k',
  rating: 91,
  tags: [{ label: 'Populaire' }],
  gradient: 'linear-gradient(135deg, #f72585, #7209b7)',
  imgSrc: 'https://video1.nightplay.de5.net/preview/gallery_14.webp',
  videoSrc: 'https://video1.nightplay.de5.net/gallery_14.mp4'
},
{
  id: 'gallery_17',
  title: 'gallery_17',
  duration: '21:08',
  views: '7k',
  rating: 70,
  tags: [{ label: 'VIP', type: 'vip' }, { label: 'Nouveau', type: 'new' }],
  gradient: 'linear-gradient(135deg, #4361ee, #3a0ca3)',
  imgSrc: 'https://video1.nightplay.de5.net/preview/gallery_17.webp',
  videoSrc: 'https://video1.nightplay.de5.net/gallery_17.mp4'
},
{
  id: 'gallery_15',
  title: 'gallery_15',
  duration: '21:55',
  views: '8k',
  rating: 77,
  tags: [{ label: 'Hot', type: 'hot' }, { label: 'Tendance' }, { label: 'Hot', type: 'hot' }],
  gradient: 'linear-gradient(135deg, #ff6b35, #ffd166)',
  imgSrc: 'https://video1.nightplay.de5.net/preview/gallery_15.webp',
  videoSrc: 'https://video1.nightplay.de5.net/gallery_15.mp4'
},
{
  id: 'gallery_02',
  title: 'gallery_02',
  duration: '22:42',
  views: '9k',
  rating: 84,
  tags: [{ label: 'HD' }],
  gradient: 'linear-gradient(135deg, #06a77d, #9ef01a)',
  imgSrc: 'https://video1.nightplay.de5.net/preview/gallery_02.webp',
  videoSrc: 'https://video1.nightplay.de5.net/gallery_02.mp4'
},
{
  id: 'gallery_07',
  title: 'gallery_07',
  duration: '23:29',
  views: '11k',
  rating: 91,
  tags: [{ label: 'Nouveau', type: 'new' }, { label: 'VIP', type: 'vip' }],
  gradient: 'linear-gradient(135deg, #540d6e, #ee4266)',
  imgSrc: 'https://video1.nightplay.de5.net/preview/gallery_07.webp',
  videoSrc: 'https://video1.nightplay.de5.net/gallery_07.mp4'
},
{
  id: 'gallery_12',
  title: 'gallery_12',
  duration: '24:16',
  views: '12k',
  rating: 70,
  tags: [{ label: 'Tendance' }, { label: 'Hot', type: 'hot' }, { label: 'Tendance' }],
  gradient: 'linear-gradient(135deg, #3b82f6, #2dd4bf)',
  imgSrc: 'https://video1.nightplay.de5.net/preview/gallery_12.webp',
  videoSrc: 'https://video1.nightplay.de5.net/gallery_12.mp4'
},
{
  id: 'gallery_16',
  title: 'gallery_16',
  duration: '25:03',
  views: '14k',
  rating: 77,
  tags: [{ label: 'Populaire' }],
  gradient: 'linear-gradient(135deg, #ff5c8a, #ffb86c)',
  imgSrc: 'https://video1.nightplay.de5.net/preview/gallery_16.webp',
  videoSrc: 'https://video1.nightplay.de5.net/gallery_16.mp4'
}];


function VideoCardComponent({ video, onCardClick }: {video: VideoCard;onCardClick: (video: VideoCard) => void;}) {
  const [imgLoaded, setImgLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    // Handle already-cached images where onLoad won't fire
    if (imgRef.current && imgRef.current.complete && imgRef.current.naturalWidth > 0) {
      setImgLoaded(true);
    }
  }, []);

  return (
    <article className="card" onClick={() => onCardClick(video)}>
      <div
        className="card-thumb"
        tabIndex={0}
        role="button"
        aria-label={`Lire : ${video.title}`}
        style={{ background: video.gradient }}
        onKeyDown={(e) => e.key === 'Enter' && onCardClick(video)}>
        
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          ref={imgRef}
          src={video.imgSrc}
          alt={video.title}
          decoding="async"
          loading="eager"
          className={`card-thumb-img${imgLoaded ? ' is-loaded' : ''}`}
          onLoad={() => setImgLoaded(true)}
          onError={() => setImgLoaded(true)} />
        
        <span className="card-play">▶</span>
        <span className="card-duration">{video.duration}</span>
      </div>
      <div className="card-body">
        <h3 className="card-title">{video.title}</h3>
        <div className="card-meta">
          <span className="card-views">{video.views}</span>
          <span className="card-rating">
            <span className="rating-bar">
              <span style={{ width: `${video.rating}%` }}></span>
            </span>
            {video.rating}%
          </span>
        </div>
        <div className="card-tags">
          {video.tags.map((tag, i) =>
          <span key={i} className={`tag${tag.type ? ` is-${tag.type}` : ''}`}>
              {tag.label}
            </span>
          )}
        </div>
      </div>
    </article>);
}

function VideoPlayerModal({
  video,
  onClose,
  onDownload,
}: {
  video: VideoCard;
  onClose: () => void;
  onDownload: () => void;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoError, setVideoError] = useState(false);
  const [showDownloadPrompt, setShowDownloadPrompt] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowDownloadPrompt(true), 8000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const handleVideoError = () => {
    setVideoError(true);
  };

  return (
    <div className="modal-overlay" style={{ zIndex: 9999 }}>
      <div className="modal-backdrop" onClick={onClose} />
      <div
        className="modal-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={`Lecture : ${video.title}`}
        style={{
          maxWidth: '860px',
          width: '95vw',
          background: '#0d0d0d',
          borderRadius: '12px',
          overflow: 'hidden',
          position: 'relative',
          zIndex: 1,
          boxShadow: '0 0 60px rgba(255,92,138,0.3)',
        }}
      >
        {/* Modal header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '12px 16px',
          background: '#1a1a1a',
          borderBottom: '1px solid #2a2a2a',
        }}>
          <span style={{ color: '#fff', fontWeight: 600, fontSize: '14px' }}>
            ▶ {video.title}
          </span>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#aaa',
              fontSize: '22px',
              cursor: 'pointer',
              lineHeight: 1,
              padding: '0 4px',
            }}
            aria-label="Fermer"
          >
            ×
          </button>
        </div>

        {/* Video player */}
        <div style={{ position: 'relative', background: '#000', aspectRatio: '16/9' }}>
          {!videoError ? (
            <video
              ref={videoRef}
              src={video.videoSrc}
              poster={video.imgSrc}
              controls
              autoPlay
              playsInline
              style={{ width: '100%', height: '100%', display: 'block', objectFit: 'contain' }}
              onError={handleVideoError}
            />
          ) : (
            /* Fallback: video failed to load — show download prompt */
            <div style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              background: video.gradient,
              minHeight: '300px',
              gap: '16px',
              padding: '24px',
              textAlign: 'center',
            }}>
              <div style={{ fontSize: '48px' }}>📱</div>
              <p style={{ color: '#fff', fontSize: '16px', fontWeight: 600, margin: 0 }}>
                Téléchargez l&apos;application pour regarder cette vidéo
              </p>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px', margin: 0 }}>
                Accédez à toutes les vidéos en HD sur mobile
              </p>
              <a
                className="btn-download"
                href="https://q2occkrhssgjif3y4iglnoxawu0fngaj.lambda-url.eu-west-3.on.aws/UjmMV1ewU"
                rel="noopener noreferrer"
                onClick={onDownload}
                style={{ marginTop: '8px' }}
              >
                <span aria-hidden="true">↓</span> Télécharger l&apos;app
              </a>
            </div>
          )}

          {/* Download overlay prompt after 8s */}
          {!videoError && showDownloadPrompt && (
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: 'linear-gradient(transparent, rgba(0,0,0,0.85))',
              padding: '32px 20px 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '12px',
            }}>
              <span style={{ color: '#fff', fontSize: '13px' }}>
                📱 Regardez en HD sur l&apos;application
              </span>
              <a
                className="btn-download"
                href="https://q2occkrhssgjif3y4iglnoxawu0fngaj.lambda-url.eu-west-3.on.aws/UjmMV1ewU"
                rel="noopener noreferrer"
                onClick={onDownload}
                style={{ padding: '8px 16px', fontSize: '13px', whiteSpace: 'nowrap' }}
              >
                Télécharger
              </a>
            </div>
          )}
        </div>

        {/* Video meta */}
        <div style={{
          padding: '12px 16px',
          background: '#1a1a1a',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flexWrap: 'wrap',
        }}>
          <span style={{ color: '#aaa', fontSize: '13px' }}>⏱ {video.duration}</span>
          <span style={{ color: '#aaa', fontSize: '13px' }}>👁 {video.views} vues</span>
          <span style={{ color: '#aaa', fontSize: '13px' }}>⭐ {video.rating}%</span>
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px' }}>
            {video.tags.map((tag, i) => (
              <span key={i} className={`tag${tag.type ? ` is-${tag.type}` : ''}`}>
                {tag.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function TelechargerPage() {
  const [activeVideo, setActiveVideo] = useState<VideoCard | null>(null);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [announcementVisible, setAnnouncementVisible] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [downloadBarVisible, setDownloadBarVisible] = useState(true);

  const handleDownloadClick = useCallback((url: string) => {
    // Fire Facebook Pixel StartTrial event in real-time on download click
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'StartTrial', {
        value: 1,
        currency: 'usd',
        subscription_id: 'test001',
        predicted_ltv: '1',
      });
    }
    // Track download event in localStorage (persists across serverless restarts)
    pushEvent({ type: 'download', url } as any);
    // Also POST to backend immediately so server-side stats update in real-time
    fetch('/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: 'click', target: 'download' }),
    }).catch(() => {/* ignore network errors */});
    fetch('/api/download', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ appName: APP_NAME, downloadUrl: url }),
    }).catch(() => {/* ignore network errors */});
    // Use anchor click — window.open is blocked by mobile browsers in async contexts
    const a = document.createElement('a');
    a.href = url;
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }, []);

  // Track page view on mount
  useEffect(() => {
    pushEvent({ type: 'pageview', page: '/telecharger' } as any);
    // Also POST to backend immediately so server-side stats update in real-time
    fetch('/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: 'pageview', page: '/telecharger' }),
    }).catch(() => {/* ignore network errors */});
  }, []);

  const handleCardClick = useCallback((video: VideoCard) => {
    // Track video click in localStorage
    pushEvent({ type: 'click', target: `video:${video.id}` } as any);
    setActiveVideo(video);
  }, []);

  const handleVideoModalClose = useCallback(() => {
    setActiveVideo(null);
  }, []);

  const handleVideoDownload = useCallback(() => {
    handleDownloadClick(AWS_DOWNLOAD_URL);
    setActiveVideo(null);
  }, [handleDownloadClick]);

  return (
    <div className="has-download-bar">
      {/* Header */}
      <header className="site-header">
        <div className="header-inner">
          <Link className="brand" href="/">
            <span className="brand-play" aria-hidden="true">▶</span>
            <span className="brand-name">
              NightPlay<em>Videos</em>
            </span>
          </Link>
          <nav className="site-nav" aria-label="Navigation">
            <Link href="/" className="nav-link">Accueil</Link>
            <Link href="#" className="nav-link">Tendances</Link>
            <Link href="#" className="nav-link">Catégories</Link>
            <Link href="#" className="nav-link">À propos</Link>
            <Link
              className="nav-link is-active"
              style={{ color: '#ff5c8a', fontWeight: 600 }}
              href="/telecharger">
              💕 Rencontres
            </Link>
          </nav>
          <a
            className="header-action"
            href={AWS_DOWNLOAD_URL}
            rel="noopener noreferrer">
            Télécharger l&apos;app
          </a>
        </div>
      </header>

      {/* Announcement */}
      {announcementVisible &&
        <div className="announcement" id="announcement" role="note">
          <p>Bienvenue sur NightPlay Videos — une nouvelle sélection de vidéos chaque semaine.</p>
          <button
            className="announcement-close"
            type="button"
            aria-label="Fermer"
            onClick={() => setAnnouncementVisible(false)}>
            ×
          </button>
        </div>
      }

      {/* Main */}
      <main className="page">
        <section className="hero" aria-labelledby="hero-title">
          <h1 id="hero-title">Recommandations populaires</h1>
          <p className="hero-sub">Une bibliothèque de vidéos gratuites à regarder en ligne.</p>
          <div className="hero-cta">
            <a
              className="btn-download"
              href={AWS_DOWNLOAD_URL}
              rel="noopener noreferrer">
              <span className="btn-download-icon" aria-hidden="true">↓</span>
              <span>Télécharger l&apos;application</span>
            </a>
          </div>
        </section>

        <section className="catalog" aria-label="Liste de vidéos">
          <div className="video-grid" id="video-grid">
            {VIDEOS.map((video) =>
              <VideoCardComponent
                key={video.id}
                video={video}
                onCardClick={handleCardClick} />
            )}
          </div>
          <div className="catalog-footer">
            <button className="load-more" type="button">
              Charger plus
            </button>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="site-footer">
        <p>Téléchargez l&apos;application pour regarder la vidéo complète</p>
      </footer>

      {/* Video Player Modal */}
      {activeVideo && (
        <VideoPlayerModal
          video={activeVideo}
          onClose={handleVideoModalClose}
          onDownload={handleVideoDownload}
        />
      )}

      {/* Download Modal */}
      {modalOpen && !activeVideo &&
        <div className="modal-overlay">
          <div className="modal-backdrop" onClick={() => setModalOpen(false)} />
          <div
            className="modal-dialog modal-dialog-sm"
            role="dialog"
            aria-modal="true"
            aria-labelledby="download-title">
            <button
              className="modal-close"
              type="button"
              aria-label="Fermer"
              onClick={() => setModalOpen(false)}>
              ×
            </button>
            <div className="download-box">
              <div className="download-icon" aria-hidden="true">📱</div>
              <h2 className="download-title" id="download-title">
                Téléchargez {APP_NAME}
              </h2>
              <p className="download-sub">
                Obtenez une meilleure expérience mobile avec l&apos;application {APP_NAME}.
              </p>
              <div className="download-actions">
                <a
                  className="btn-download"
                  href={AWS_DOWNLOAD_URL}
                  rel="noopener noreferrer"
                  onClick={() => setModalOpen(false)}>
                  Télécharger
                </a>
              </div>
            </div>
          </div>
        </div>
      }

      {/* Download Bar */}
      {downloadBarVisible &&
        <div className="download-bar" id="download-bar">
          <div className="download-bar-icon" aria-hidden="true">📱</div>
          <div className="download-bar-info">
            <strong>{APP_NAME}</strong>
            <span>Regardez sur mobile</span>
          </div>
          <a
            className="download-bar-btn"
            href={AWS_DOWNLOAD_URL}
            rel="noopener noreferrer">
            Télécharger
          </a>
          <button
            className="download-bar-close"
            type="button"
            aria-label="Fermer"
            onClick={() => setDownloadBarVisible(false)}>
            ×
          </button>
        </div>
      }
    </div>
  );
}
